var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"file-preview-wrap"},_vm._l((_vm.srcList),function(url,key){return _c(_vm.getUrlType(url) + 'Preview',{key:key,tag:"component",attrs:{"src":_vm.asUrl(url)}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }